<template>
    <button :type="type" :class="'button-' + appearance">
        <slot />
    </button>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        type: {
            type: String,
            default: 'submit',
        },

        appearance: {
            type: String,
            default: 'primary',
        },
    },

    computed: {
        class() {
            return 'button-primary';
        },
    },
});
</script>
